import React from 'react';
import LoginEmail from '../Pages/Auth/LoginEmail';
import SignUpPage from '../Pages/Auth/SignUpPage';
import RedirectElement from '../Pages/Auth/RedirectElement';
import RecruitmentSignUp from '../Pages/Recruitment/RecruitmentSignUp';
import RecruitmentLogIn from '../Pages/Recruitment/RecruitmentLogIn';
import ForgotPassword from '../Pages/Auth/ForgotPassword';
import EmailVerification from '../Pages/Auth/EmailVerification';
import RecruitmentUserPage from '../Pages/Recruitment/RecruitmentUserPage';
import RecruitmentWealthDynamic from '../Pages/Recruitment/RecruitmentWealthDynamic';
import FrontRecruitmentRouter from './FrontRecruitmentRouter';
import RedirectElementSessions from '../Pages/Auth/RedirectElementSessions';

const AuthenticationRouter = [
  {
    path: '/:segmen1',
    element: <RedirectElementSessions />,
  },
  {
    path: '/:segmen1/:segmen2',
    element: <RedirectElementSessions />,
  },
  {
    path: '/',
    element: <RedirectElement />,
  },
  {
    path: '/login',
    element: <LoginEmail />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/login/recruitment',
    element: <RecruitmentLogIn />,
  },
  {
    path: '/signup/recruitment',
    element: <RecruitmentSignUp />,

  },

  {
    path: '/recruitment',
    element: <RecruitmentUserPage />,

  },
  {
    path: '/recruitment/*',
    element: <FrontRecruitmentRouter />,

  },
  {
    path: '/wealth-dynamic',
    element: <RecruitmentWealthDynamic/>
  },


  {

    path: '/verificationEmail',
    element: <EmailVerification />,
  },
  {
    path: '/reset-password',
    element: <ForgotPassword />,
  },
];

export default AuthenticationRouter;
